import { FC } from 'react';
import { Button, Modal } from 'flowbite-react';
import { t } from 'i18next';
import { IMedia } from '../../common/interfaces/Media.interface';

interface Props {
  isOpen: boolean;
  item: IMedia | null;
  onClose: () => void;
}

const MediaModal: FC<Props> = ({ isOpen, item, onClose }) => {
  if (!item) return null;

  const renderPreview = () => {
    const normalizedType = item.type.toLowerCase();
    switch (normalizedType) {
      case 'image':
        return (
          <img
            src={item.url}
            alt={item.name}
            className="max-h-[400px] w-full object-contain"
            loading="lazy"
          />
        );
      case 'video':
        return (
          <video controls className="max-h-[400px] w-full object-contain">
            <source src={item.url} type="video/mp4" />
            {t('media.notSupported')}
          </video>
        );
      case 'sound':
        return (
          <audio controls src={item.url} className="mx-auto w-full">
            {t('media.notSupported')}
          </audio>
        );
      case 'document':
        return (
          <iframe src={item.url} title={item.name} className="h-[500px] w-full">
            {t('media.notSupported')}
          </iframe>
        );
      default:
        return <p>{t('media.notSupported')}</p>;
    }
  };

  return (
    <Modal show={isOpen} size="4xl" onClose={onClose}>
      <Modal.Header className="modal-header">
        <div className="flex-1">{t(`mediaTypes.${item.type}`)}</div>
      </Modal.Header>
      <Modal.Body>
        <div className="relative mx-auto flex w-full max-w-[600px] items-center justify-center overflow-hidden">
          {renderPreview()}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} color="gray" className="ms-auto">
          {t('media.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MediaModal;
